import { connect } from "dva";
import { Reports } from "./Reports";
import { routerRedux } from "dva/router";

const fetchActionURL = "users/getAllCompanies";;
export const mapStateToProps = (state, ownProps) => {
  const { loading, users } = state;
  const { usersList, usersTotal, createUserModal, deleteUserModal, resetModal, viewUserModal  } = users;
  const isLoading = loading.effects[fetchActionURL];


    return {
      isLoading,
      usersList,
      usersTotal,
      fetchActionURL,
      createUserModal,
      deleteUserModal,
      resetModal,
      viewUserModal
    }
}
export const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      redirect(pathname) {
        dispatch(routerRedux.push({ pathname: `${pathname}` }));
      },
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
  )((Reports));